module.exports = __webpack_public_path__ + "static/media/logo-white.09730bf8.webp";